module.exports = __webpack_public_path__ + "img/jaminan-kepuasan.365ea964.svg";